import { render } from "./hotTable.vue?vue&type=template&id=987f84d2&scoped=true&ts=true"
import script from "./hotTable.vue?vue&type=script&lang=ts"
export * from "./hotTable.vue?vue&type=script&lang=ts"

import "./hotTable.vue?vue&type=style&index=0&id=987f84d2&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987f84d2"]])

export default __exports__